import TrophySVG from "@design-system/ui-icons/vanilla/Trophy"
import { createIcon } from "../createIcon"

export const TrophyIcon = createIcon(TrophySVG)
